import { useState } from "react";

// COMPONENTS
import Wrapper from "../../../../components/helpers/Wrapper";
import Tab from "../../../../components/ui/Tab";

// PAGES
import WebsiteCountryLocation from "./CountryLocation";
import WebsiteCityLocation from "./CityLocation";

// UTILS
import { IAEvent_Secondary_Tab_Visit } from "../../../../utils/IAEvents";

const WebsiteLocation = ({ viewId }) => {

    const tabData = [
        "Geo Location - Country",
        "Geo Location - City"
    ];

    const [selectedTab, setSelectedTab] = useState(tabData[0]);

    // TO SET THE ACTIVE TAB ONCLICK
    const handleCallback = (event) => {
        if (selectedTab !== event) {
            setSelectedTab(event);
        }
        IAEvent_Secondary_Tab_Visit("Marketing Intelligence", "Website", null, "Location", event)
    }

    return (
        <Wrapper>
            <div className="grid grid_margin_bottom">
                <Tab
                    varient={"secondary"}
                    tabData={tabData}
                    activeTab={selectedTab}
                    handleCallback={(event) => handleCallback(event)} />
            </div>
            {selectedTab.toLowerCase() === tabData[0].toLowerCase() && <WebsiteCountryLocation viewId={viewId} />}
            {selectedTab.toLowerCase() === tabData[1].toLowerCase() && <WebsiteCityLocation viewId={viewId} />}
        </Wrapper>
    );
};

export default WebsiteLocation;
